import React from 'react';
import { Col, Container, Row } from 'reactstrap';

// Import Images
import error500 from '../../assets/images/error500.png';
import { useTrans } from '../../Components/Hooks/UserHooks';

const Unavailable = ({ error, errorInfo }) => {
    const t = useTrans('translation');

    return (
        <React.Fragment>
            <Container fluid={true}>
                <Row className="justify-content-center ">
                    <Col xl={6} className="text-center">
                        <div>
                            {/* <h3>{t('ise')}</h3> */}
                            <h1 className="text-muted w-75 mx-auto">
                                {t(
                                    'Apologies for the inconvenience. The survey is down for maintenance, and should be back up shortly. We’re working to improve the user experience. Please come back soon.'
                                )}
                            </h1>

                            {/* <details></details> */}
                        </div>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default Unavailable;
